export default {
  inserted: el => {
    function loadImage () {
      const imageElement = Array.from(el.children).find(
        el => el.nodeName === 'IMG'
      ) || el

      if (imageElement && imageElement.dataset.url !== '') {
        imageElement.addEventListener('load', () => {
          setTimeout(() => el.classList.add('loaded'), 100)
        })
        imageElement.addEventListener('error', () => {
          el.src = require('@/assets/images/profilephoto.svg')
        })

        imageElement.src = imageElement.dataset.url
      } else if (imageElement && imageElement.dataset.url === '') {
        imageElement.src = require('@/assets/images/profilephoto.svg')
      }
    }

    function handleIntersect (entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage()
          observer.unobserve(el)
        }
      })
    }

    function createObserver () {
      const options = {
        root: null,
        threshold: '0'
      }
      const observer = new IntersectionObserver(handleIntersect, options)
      observer.observe(el)
    }

    if (window['IntersectionObserver']) {
      createObserver()
    } else {
      loadImage()
    }
  },
  update: el => {
    function loadImage () {
      const imageElement = Array.from(el.children).find(
        el => el.nodeName === 'IMG'
      ) || el

      if (imageElement && imageElement.dataset.url !== '') {
        imageElement.addEventListener('load', () => {
          setTimeout(() => el.classList.add('loaded'), 100)
        })
        imageElement.addEventListener('error', () => {
          el.src = require('@/assets/images/profilephoto.svg')
        })

        imageElement.src = imageElement.dataset.url
      } else if (imageElement && imageElement.dataset.url === '') {
        imageElement.src = require('@/assets/images/profilephoto.svg')
      }
    }

    loadImage()
  }
}
